
import { MainLayout } from "@/components/layout/MainLayout";
import { fileStorage } from "@/utils/fileStorage";
import { useEffect, useState } from "react";
import { FileItem } from "@/pages/admin/files/types";

export default function ResourcesDocuments() {
  const [documents, setDocuments] = useState<FileItem[]>([]);
  
  useEffect(() => {
    // Load documents from the database (localStorage)
    const loadedDocuments = fileStorage.getFilesByCategory("documents");
    setDocuments(loadedDocuments);
  }, []);

  return (
    <MainLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Πρότυπες Μελέτες</h1>
        <p className="text-muted-foreground mb-6">
          Εδώ θα βρείτε όλα τα εκπαιδευτικά έγγραφα και οδηγούς για διάφορα θέματα.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {documents.length > 0 ? (
            documents.map((document) => (
              <div key={document.id} className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                <div className="flex items-center gap-3 mb-3">
                  <FileIcon className="h-8 w-8 text-primary" />
                  <div>
                    <h3 className="font-medium">{document.title || document.name}</h3>
                    <p className="text-xs text-muted-foreground">{document.type.toUpperCase()} • {document.size}</p>
                  </div>
                </div>
                {document.description && (
                  <p className="text-sm text-muted-foreground mb-3">
                    {document.description}
                  </p>
                )}
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Ημ/νία: {document.uploadDate}</span>
                  <a 
                    href={document.url} 
                    download={document.name} 
                    className="text-primary text-sm hover:underline"
                  >
                    Λήψη
                  </a>
                </div>
              </div>
            ))
          ) : (
            <div className="col-span-3 text-center py-10">
              <p className="text-muted-foreground">Δεν βρέθηκαν πρότυπες μελέτες.</p>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
}

function FileIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  );
}
